import {
  Dialog,
  DialogTitle,
  Divider,
  DialogContent,
  Typography,
  TextField,
  DialogActions,
  Button,
  Chip,
  Stack,
} from "@mui/material";
import React from "react";
import { Appointment } from "../../../../context/appContext";
import { AppointmentsParticipantContext } from "../context/appointmentsParticipantContext";

const CancelAppointmentDialog = ({
  openCancelDialog,
  handleCloseCancelDialog,
  appointment,
  reason,
  setReason,
}: {
  openCancelDialog: boolean;
  handleCloseCancelDialog: () => void;
  appointment: Appointment;
  reason: string;
  setReason: React.Dispatch<React.SetStateAction<string>>;
}): React.JSX.Element => {
  const {
    cancelAppointment,
  }: {
    cancelAppointment: (appointment: Appointment, reason: string) => void;
  } = React.useContext(AppointmentsParticipantContext);

  return (
    <Dialog
      open={openCancelDialog}
      onClose={handleCloseCancelDialog}
      aria-labelledby={"alert-dialog-title"}
      aria-describedby={"alert-dialog-description"}
    >
      <DialogTitle id={"alert-dialog-title"}>Termin Stornieren</DialogTitle>

      <Divider />

      <DialogContent>
        <Typography variant="body1" color="initial">
          Möchten Sie einen Grund für die Stornierung angeben?
        </Typography>

        <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
          {["Jobaufnahme", "Krankheit"].map((preset) => (
            <Chip
              key={preset}
              label={preset}
              clickable
              color={reason === preset ? "primary" : "default"}
              variant={reason === preset ? "filled" : "outlined"}
              onClick={() => setReason(reason === preset ? "" : preset)}
            />
          ))}
        </Stack>

        <TextField
          sx={{
            mt: 2,
          }}
          value={reason}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setReason(event.target.value)
          }
          fullWidth
          minRows={3}
          multiline
          placeholder="Dies ist optional..."
        />
      </DialogContent>

      <Divider />

      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "space-between",
          p: 2,
        }}
      >
        <Button onClick={handleCloseCancelDialog} color="primary">
          Abbrechen
        </Button>

        <Button
          onClick={() => cancelAppointment(appointment, reason)}
          color="primary"
          variant="contained"
        >
          Termin stornieren
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelAppointmentDialog;
